export default {
	host:'https://api.aicchat.online',
	socketurl:'wss://ws.aicchat.online'
}
